// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionOperators_SaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/production_operators/salvar
 *
 * Create or update a production operator.
 */
import { registerContract } from './validate'

export interface ProductionOperators_SaveInput {
display_name: string
production_operator_id?: number
franchise_id?: number
badge_qrcode?: string
badge_number?: string
cognito_user_id?: string
is_active?: number
avatar_url?: string
color_hex?: string
}

registerContract('ProductionOperators_SaveInput', {
  display_name:           { type: 'string',  required: true },
  production_operator_id: { type: 'number',  required: false },
  franchise_id:           { type: 'number',  required: false },
  badge_qrcode:           { type: 'string',  required: false },
  badge_number:           { type: 'string',  required: false },
  cognito_user_id:        { type: 'string',  required: false },
  is_active:              { type: 'number',  required: false },
  avatar_url:             { type: 'string',  required: false },
  color_hex:              { type: 'string',  required: false },
})
